import styled from 'styled-components';

export const NpsValContainer = styled.div`
  width: 100%;
  top: 55px;
  position: absolute;
  padding: 0 4px;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.white.a10};
  font-weight: 200;
`;

export const NpsValue = styled.div`
  max-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    max-width: inherit;
    width: auto;
  }
`;
